import { BrowserRouter as Router } from 'react-router-dom';
import { PagesProvider, PopUpProvider, ColorProvider } from '#context';
import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import App from './App.jsx';
import './style/index.js';

createRoot(document.getElementById('root')).render(
    <StrictMode>
        <Router>
            <PagesProvider>
                <PopUpProvider>
                    <ColorProvider>
                        <App />
                    </ColorProvider>
                </PopUpProvider>
            </PagesProvider>
        </Router>
    </StrictMode>,
);
